import React, { useEffect, useState } from "react";
import { BASE_URL } from "../Const/Url";
import { logout_func2 } from "../Const/logoutCommon";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loader from "../CustomCommons/Loader";
import { showToast } from "../../utils/ToastHelper";
import { Form, InputGroup } from "react-bootstrap";
import swal from "sweetalert";

const NavigationMenu = () => {
  const [navItems, setNavItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [OnlogoutHide, setOnlogoutHide] = useState(0);
  const history = useHistory();

  // Default menu items if there are none in the database
  const defaultNavItems = [
    { slug: "home", name: "Home", is_active: true, order: 1 },
    { slug: "home-decor", name: "Home Decor", is_active: true, order: 2 },
    { slug: "in-style", name: "In Style", is_active: true, order: 3 },
    { slug: "festival-collection", name: "Eid Collection", is_active: true, order: 4 },
    { slug: "about", name: "About Us", is_active: true, order: 5 },
    { slug: "offer", name: "Offer", is_active: true, order: 6 },
    { slug: "new-arrival", name: "New Arrival", is_active: true, order: 7 },
    { slug: "contact", name: "Contact Us", is_active: true, order: 8 },
  ];

  // Get authentication token from localStorage
  const getAuthHeader = () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const token = userData?.token;
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    };
  };

  // Fetch all navigation menu items
  const fetchNavItems = () => {
    axios
      .get(`${BASE_URL}api/v1/utility/admin/navbar/`, getAuthHeader())
      .then((res) => {
        console.log(res.data, "res.data");
        if (res.data.data && res.data.data.results.length > 0) {
          console.log(res.data.data, "res.data.data");
          setNavItems(res.data.data.results);
        } else {
          // If no items, use default list
          setNavItems(defaultNavItems);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        console.log(err.request.response);
        if (
          message === "Invalid token." ||
          JSON.parse(err.request.response).code === 401
        ) {
          logout_func2(setOnlogoutHide, history);
        }
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchNavItems();
  }, []);

  // Handle toggle change for a navigation item
  const handleToggleChange = (slug, index) => {
    const updatedNavItems = [...navItems];
    updatedNavItems[index].is_active = !updatedNavItems[index].is_active;
    setNavItems(updatedNavItems);

    // Update the item status in the backend
    const itemToUpdate = updatedNavItems[index];
    axios
      .patch(
        `${BASE_URL}api/v1/utility/admin/navbar/${slug}/`, 
        {
          // slug: itemToUpdate.slug,
          name: itemToUpdate.name,
          is_active: itemToUpdate.is_active,
          order: itemToUpdate.order
        },
        getAuthHeader()
      )
      .then((res) => {
        showToast("success", `${itemToUpdate.name} updated successfully`);
      })
      .catch((err) => {
        // Revert the change in UI if the API call fails
        const revertedNavItems = [...navItems];
        revertedNavItems[index].is_active = !revertedNavItems[index].is_active;
        setNavItems(revertedNavItems);
        
        showToast("error", "Failed to update navigation item");
        console.log(err.response?.data || err);
      });
  };

  // Handle change in the order of items
  const handleOrderChange = (slug, index, newOrder) => {
    if (newOrder < 1) return;
    
    const updatedNavItems = [...navItems];
    updatedNavItems[index].order = newOrder;
    
    // Sort by order
    updatedNavItems.sort((a, b) => a.order - b.order);
    setNavItems(updatedNavItems);

    const itemToUpdate = updatedNavItems.find(item => item.slug === slug);
    if (!itemToUpdate) return;

    axios
      .put(
        `${BASE_URL}api/v1/utility/admin/navbar/${slug}/`, 
        {
          slug: itemToUpdate.slug,
          name: itemToUpdate.name,
          is_active: itemToUpdate.is_active,
          order: newOrder
        },
        getAuthHeader()
      )
      .then((res) => {
        showToast("success", `${itemToUpdate.name} order updated`);
      })
      .catch((err) => {
        showToast("error", "Failed to update order");
        console.log(err.response?.data || err);
        // Revert back and refetch
        fetchNavItems();
      });
  };

  // Reset all navigation items to default
  const resetToDefault = () => {
    swal({
      title: "Are you sure?",
      text: "This will reset all navigation items to default settings",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willReset) => {
      if (willReset) {
        setIsLoading(true);
        
        // Create promises for updating all items
        const updatePromises = defaultNavItems.map(item => {
          return axios.put(
            `${BASE_URL}api/v1/utility/admin/navbar/${item.slug}/`, 
            {
              slug: item.slug,
              name: item.name,
              is_active: item.is_active,
              order: item.order
            },
            getAuthHeader()
          );
        });
        
        Promise.all(updatePromises)
          .then(() => {
            showToast("success", "Navigation menu reset to default");
            fetchNavItems();
          })
          .catch((err) => {
            showToast("error", "Failed to reset navigation menu");
            console.log(err);
            setIsLoading(false);
          });
      }
    });
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="categorey-parent new-categorey-parent an">
      <div className="bg-white add-div">
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ padding: "20px 35px", border: "0.5px solid #E0E0E0" }}
        >
          <h3 style={{ fontSize: "23px", marginTop: "6px" }}>
            Navigation Menu Settings
          </h3>
          <button 
            className="btn btn-secondary"
            onClick={resetToDefault}
          >
            Reset to Default
          </button>
        </div>
        <div
          style={{
            padding: "20px 35px",
          }}
        >
          <p className="mb-4">Enable or disable menu items and adjust their display order.</p>
          
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="bg-dark text-white">
                <tr>
                  <th style={{ width: "5%" }}>#</th>
                  <th style={{ width: "40%" }}>Menu Item</th>
                  <th style={{ width: "25%" }}>Status</th>
                  <th style={{ width: "30%" }}>Order</th>
                </tr>
              </thead>
              <tbody>
                {navItems.sort((a, b) => a.order - b.order).map((item, index) => (
                  <tr key={item.slug}>
                    <td>{index + 1}</td>
                    <td>{item.name}</td>
                    <td>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id={`switch-${item.slug}`}
                          checked={item.is_active}
                          onChange={() => handleToggleChange(item.slug, index)}
                          style={{ width: "3em", height: "1.5em" }}
                        />
                        <label className="form-check-label ms-2" htmlFor={`switch-${item.slug}`}>
                          {item.is_active ? "Visible" : "Hidden"}
                        </label>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <InputGroup style={{ maxWidth: "150px" }}>
                          <Form.Control
                            type="number"
                            value={item.order}
                            min="1"
                            onChange={(e) => 
                              handleOrderChange(item.slug, index, parseInt(e.target.value) || 1)
                            }
                          />
                        </InputGroup>
                        <span className="ms-3 text-muted">(Lower number appears first)</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavigationMenu; 